/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector } from '@angular/core';
import { type Command, type PromptConfigFull, DeleteAbstract } from '@dm/core';
import { type CIFSShare } from 'app/common/types/mo';

import { ShareTypeE } from '../../share.enum';
import { CifsShareStrService } from '../cifs-share-str.service';
import { CifsShareService } from './../cifs-share.service';

@Component({
    selector: 'app-delete-cifs-share',
    templateUrl: './delete-cifs-share.component.html',
    styleUrls: ['./delete-cifs-share.component.scss'],
})
export class DeleteCifsShareComponent extends DeleteAbstract<CIFSShare> {
    i18n = this.str.i18n;

    constructor(
        injector: Injector,
        private str: CifsShareStrService,
        private cifsService: CifsShareService,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'NAME',
                header: this.i18n.label.share_name,
                className: ['table-cell-text-pre'],
            },
            {
                field: 'ID',
                header: this.i18n.label.id,
            },
            {
                field: 'subType',
                header: this.i18n.label.homedir,
                filterType: 'dropdown',
                options: this.str.homedirOpts,
                columnFilter: true,
                render: (value) => value === ShareTypeE.Homedir ? this.i18n.value.yes : this.i18n.value.no,
            },
        ];
    }

    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [
            {
                id: 'prompt-delete-cifs-share-deleteCIFS',
                canHidden: true,
                opType: 'warning',
                title: this.i18n.title.deleteShare,
                content: this.i18n.highRisk.deleteCIFS,
                templateRef: this.tableTemplate,
                width: 700,
            },
        ];

        return prompts;
    }

    buildCmds(): Command[] {
        const cmds: Command[] = this.dataList.map((a) => ({
            name: a.subType === ShareTypeE.Homedir ? this.i18n.rest.homedir.delete : this.i18n.rest.deleteCIFS,
            nameParams: [a.NAME],
            action: this.cifsService.delete(a.ID, a.vstoreId),
        }));

        return cmds;
    }
}
